import { Trash2 } from 'lucide-react';

import type { ShoutOut } from '@/api/comms/shoutOuts.api';
import { Badge } from '@/components/ui/Badge';
import { Card } from '@/components/ui/Card';

/**
 * One core-value shout-out in the feed. Display-only plus an optional
 * delete affordance for the giver or a moderator (`manage_eos`).
 */
export function ShoutOutCard({
  shoutOut,
  canDelete,
  onDelete,
  deletePending,
}: {
  shoutOut: ShoutOut;
  canDelete: boolean;
  onDelete: (id: string) => void;
  deletePending?: boolean;
}) {
  return (
    <Card className="p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[14px] text-kw-shark">
            <span className="font-semibold">{shoutOut.recipientNameSnapshot}</span>
            <span className="text-kw-muted"> recognized for </span>
          </p>
          <div className="mt-1">
            <Badge variant="info">{shoutOut.coreValue}</Badge>
          </div>
          <p className="mt-2 whitespace-pre-wrap text-[13px] text-kw-shark">{shoutOut.message}</p>
          <p className="mt-2 text-[12px] text-kw-muted">
            From {shoutOut.giverNameSnapshot || 'A teammate'} ·{' '}
            {new Date(shoutOut.createdAt).toLocaleDateString(undefined, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}
          </p>
        </div>
        {canDelete ? (
          <button
            type="button"
            aria-label={`Delete shout-out for ${shoutOut.recipientNameSnapshot}`}
            disabled={deletePending}
            onClick={() => {
              onDelete(shoutOut.id);
            }}
            className="shrink-0 rounded-kw-md p-1.5 text-kw-muted hover:bg-kw-bg hover:text-kw-danger-text disabled:opacity-40"
          >
            <Trash2 className="size-4" />
          </button>
        ) : null}
      </div>
    </Card>
  );
}
